import { Spinner } from "components";
import InputField from "components/InputField/InputField";

export default function TwoFactorChallenge({
  code,
  onChange,
  onSubmit,
  onCancel,
  isPending,
}) {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm leading-6" style={{ color: "var(--layout-text-muted)" }}>
        أدخل رمز التحقق من تطبيق المصادقة لإكمال تسجيل الدخول.
      </p>
      <InputField
        title="رمز التحقق"
        id="twoFactorCode"
        type="text"
        value={code}
        onChange={(target) => onChange(target.value)}
        direction="ltr"
        placeholder="123456"
      />
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
        <button
          type="button"
          onClick={(event) => onSubmit(event)}
          className="portal-outline-button min-w-32 rounded-xl px-5 py-3 font-bold"
        >
          {!isPending ? "تأكيد" : <Spinner sm />}
        </button>
        <button
          type="button"
          onClick={onCancel}
          disabled={isPending}
          className="rounded-xl border border-white/15 bg-white/10 px-5 py-3 font-bold transition hover:bg-white/15 disabled:opacity-70"
          style={{ color: "var(--layout-text)" }}
        >
          إلغاء
        </button>
      </div>
    </div>
  );
}
